import { STORY_MODE_CHAPTERS } from './story.js';
import { getDialogueForBeat } from './dialogue.js';

export const ROUTE = STORY_MODE_CHAPTERS.find((chapter) => chapter.id === 'rooftop-route');
export const NEXT_CHAPTER = STORY_MODE_CHAPTERS[STORY_MODE_CHAPTERS.indexOf(ROUTE) + 1];
export const ROUTE_OBJECTIVES = ROUTE.beats.map((beat) => beat.objective);

export function adaptObjectives(objectives = ROUTE_OBJECTIVES) {
  return objectives.map((objective) => ({ ...objective }));
}

export function routeInteractables(objectives = ROUTE_OBJECTIVES) {
  return objectives.flatMap((objective) => objective.interactables ?? []);
}

export function getComms(beatId, heard = []) {
  return getDialogueForBeat(beatId)
    .filter((line) => !heard.includes(line.id))
    .map((line) => ({ ...line, durationMs: line.duration }));
}

/** Rebuild authored safe states; never restore browser-supplied coordinates. */
export function routeSession(progress) {
  const route = progress?.route;
  const objectiveIndex = route?.objectiveIndex ?? 0;
  const completed = [...(route?.completed ?? [])];
  let z = ROUTE_OBJECTIVES[objectiveIndex - 1]?.threshold ?? 24;
  for (const item of routeInteractables()) {
    if (completed.includes(item.id)) z = Math.min(z, item.position[2] + 2);
  }
  return {
    objectiveIndex,
    position: [0, 1.72, z],
    inventory: routeInteractables().flatMap((item) => completed.includes(item.id) ? item.grants ?? [] : []),
    completed,
    heard: [...(route?.heard ?? [])],
  };
}
